import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import PageTitle from './components/pageTitle'
import Layout from './components/layout'
import { ThemeProvider } from './components/themeProvider'
import Home from './pages/home'
import About from './pages/about'
import Background from './components/layout/background'
import Contact from './pages/contact'
import Portal from './pages/portal'
import Impressum from './pages/impressum'
import AGB from './pages/agb'
import Privacy from './pages/privacy'
import Blog from './pages/blog'
import BlogPost from './pages/blogPost'

/**
 * Main App component with routes and enhanced scroll animation setup
 */
const App = () => {
  // Set up scroll animations using Intersection Observer
  useEffect(() => {
    // Create observer for scroll animations
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Toggle the class based on visibility
        if (entry.isIntersecting) {
          entry.target.classList.add('section-visible');
        } else {
          // Remove the class when not visible to allow re-animation
          entry.target.classList.remove('section-visible');
        }
      });
    }, { 
      threshold: 0.15,  // Trigger when 15% of element is visible
      rootMargin: "0px 0px -100px 0px" // Slightly offset to trigger animations earlier
    });

    // Observe all sections for animation
    const animateSections = document.querySelectorAll('.animate-section');
    animateSections.forEach(section => {
      sectionObserver.observe(section);
    });

    // Clean up function for when component unmounts
    return () => {
      if (animateSections.length > 0) {
        sectionObserver.disconnect();
      }
    };
  }, []);

  return (
    <ThemeProvider>
      <Background>
        <Layout>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <PageTitle titleKey="PathConnect" />
                  <Home />
                </>
              }
            />
            <Route
              path="/portal"
              element={
                <>
                  <PageTitle titleKey="portal" />
                  <Portal />
                </>
              }
            />
            <Route
              path="/about"
              element={
                <>
                  <PageTitle titleKey="about" />
                  <About />
                </>
              }
            />
            <Route
              path="/contact"
              element={
                <>
                  <PageTitle titleKey="contact" />
                  <Contact />
                </>
              }
            />
            {/* Blog Routes */}
            <Route
              path="/blog"
              element={
                <>
                  <PageTitle titleKey="blog.blog-title" />
                  <Blog />
                </>
              }
            />
            <Route
              path="/blog/:slug"
              element={
                <>
                  <PageTitle titleKey="blog.post-title" />
                  <BlogPost />
                </>
              }
            />
            <Route
              path="/impressum"
              element={
                <>
                  <PageTitle titleKey="impressum" />
                  <Impressum />
                </>
              }
            />
            <Route
              path="/agb"
              element={
                <>
                  <PageTitle titleKey="agb" />
                  <AGB />
                </>
              }
            />
            <Route
              path="/privacy"
              element={
                <>
                  <PageTitle titleKey="privacy" />
                  <Privacy />
                </>
              }
            />
          </Routes>
        </Layout>
      </Background>
    </ThemeProvider>
  )
}

export default App